import React, { FunctionComponent } from "react";
import DynamicVideo from "components/dynamicVideo";
import "./index.scss";
import { ContentPageItemCollection } from "services/entities/content";
import ContentItem from "components/content/ContentItem";

type VideoHeroProps = {
  code?: string;
};

export const VideoHero: FunctionComponent<VideoHeroProps> = ({ code }) => {
  return (
    <section className={`content-mw section--video-hero`}>
      {code && (
        <ContentItem code={code}>
          {(item) => {
            return (
              <>
                {(item as ContentPageItemCollection) && (
                  <span className="banner-image">
                    {(item as ContentPageItemCollection) && (
                      <DynamicVideo item={item as ContentPageItemCollection} />
                    )}
                  </span>
                )}
              </>
            );
          }}
        </ContentItem>
      )}
    </section>
  );
};
//https://player.vimeo.com/video/488488094?h=01534c6250&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479

export default VideoHero;
